<div class="switch-control" [ngClass]="{'disabled': disable}">
  <p (click)="secondary(!value)">
    <ng-content></ng-content>
  </p>
  <div class="switch-holder">
    <input type="checkbox" #inlineEditControl id="toggle-button-checkbox-{{id}}"
           [(ngModel)]="value" [disabled]="disable">
    <label class="toggle-button-switch"
           for="toggle-button-checkbox-{{id}}"></label>
    <div class="toggle-button-text" (click)="secondary(!value)">
      <div class="toggle-button-text-on">On      
      </div>
      <div class="toggle-button-text-off">
        Off
      </div>
    </div>
  </div>
</div>
